<template>
  <div class="responses-container">
    <h2>Your Responses</h2>
    <div class="response-card" v-for="(answer, index) in answers" :key="index">
      <div style="margin-bottom: 10px;">
        <span class="question-id">{{ answer.questionCategory }}</span>
      </div>
      <div class="question-header">
        <div>
          <span class="question-id">{{ answer.questionId }}</span>
          <span class="question-text">{{ answer.questionText }}</span>
        </div>
      </div>
      <div class="answer-section">
        <textarea
          v-model="answer.answer"
          placeholder="Your answer..."
        ></textarea>
      </div>
    </div>
    <button class="btn" @click="updateResponses">Save</button>
  </div>
</template>


<script>
import api from "@/api";
import { fetchQuestion} from "../api";

export default {
  name: "DashboardPage",
  data() {
    return {
      // Each answer object will eventually have a questionId, answer, and the fetched question
      answers: [],
    };
  },
  async created() {
    const token = localStorage.getItem("token");

    // Retrieve the responses from the API
    const { data } = await api.get("/responses", {
      headers: { Authorization: `Bearer ${token}` },
    });
    this.answers = data.answers || [];

    // For each answer, fetch the full question and add it to the answer object reactively
    await Promise.all(
      this.answers.map(async (answer, index) => {
        const question = await this.returnQuestion(answer.questionId);
        // Use Vue's reactive setter to ensure questionText is reactive.
        this.$set(this.answers[index], 'questionText', question.text);
        this.$set(this.answers[index], 'questionCategory', question.category);
      })
    );
    
    
    // // For each answer, fetch the full question and add it to the answer object
    // await Promise.all(
    //   this.answers.map(async (answer) => {
    //     const question = await this.returnQuestion(answer.questionId);
    //     // Add the fetched question to the answer object
    //     answer.questionText = question.text;
    //   })
    // );
  },
  methods: {
    async updateResponses() {
      const token = localStorage.getItem("token");
      await api.put(
        "/responses",
        { answers: this.answers },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Responses updated!");
    },

    // Fetch the question details for a given questionId and return the question data.
    async returnQuestion(questionId) {
      try {
        const response = await fetchQuestion(questionId);
        return response.data;
      } catch (error) {
        console.error("Error fetching question:", error);
        return null;
      }
    },
  },
};
</script>



<!-- <script>
import api from "@/api";
export default {
  name: "DashboardPage",
  data() {
    return {
      // Example answers. Each answer object includes a questionId, question text, and the user's answer.
      answers: [],
    };
  },
  async created() {
    const token = localStorage.getItem("token");
    const { data } = await api.get("/responses", {
      headers: { Authorization: `Bearer ${token}` },
    });
    this.answers = data.answers || []; 
  },
  methods: {
    async updateResponses() {
      const token = localStorage.getItem("token");
      await api.put(
        "/responses",
        { answers: this.answers },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Responses updated!");
    },
    async fetchQuestion(questionId) {
        try {
          const response = await axios.get(`/api/question/${questionId}`);
          this.question = response.data.question;
          this.answers = response.data.answers;
        } catch (error) {
          console.error("Error fetching question:", error);
        }
      }, 
  },
};
</script> -->

<style scoped>
.responses-container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background: #f5f7fa;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.responses-container h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
}

/* Card style for each answer */
.response-card {
  background: #fff;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Styling for question header */
.question-header {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.question-id {
  font-weight: bold;
  color: #3498db;
  margin-right: 0.5rem;
}

.question-text {
  color: #555;
}

/* Styling for the answer text area */
.answer-section textarea {
  width: 85%;
  /* min-height: 80px; */
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  font-family: inherit;
}

/* Button styling */
.btn {
  display: block;
  width: 100%;
  padding: 0.75rem;
  margin-top: 1rem;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
}
.btn:hover {
  background: #2980b9;
}
</style>



<!-- <template>
  <div>
    <h2>Your Responses</h2>
    <div v-for="(answer, index) in answers" :key="index">
      <p>{{ answer.questionId }}: <input v-model="answer.answer" /></p>
    </div>
    <button @click="updateResponses">Save</button>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "DashboardPage",
  data() {
    return {
      answers: [],
    };
  },
  async created() {
    const token = localStorage.getItem("token");
    const { data } = await api.get("/responses", {
      headers: { Authorization: `Bearer ${token}` },
    });
    this.answers = data.answers || [];
  },
  methods: {
    async updateResponses() {
      const token = localStorage.getItem("token");
      await api.put(
        "/responses",
        { answers: this.answers },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Responses updated!");
    },
  },
};
</script> -->



<!-- <template>
    <div>
      <h2>Your Responses</h2>
      <div v-for="(answer, index) in answers" :key="index">
        <p>{{ answer.questionId }}: <input v-model="answer.answer" /></p>
      </div>
      <button @click="updateResponses">Save</button>
    </div>
  </template>
  
  <script>
  import api from "@/api";
  
  export default {
    data() {
      return {
        answers: [],
      };
    },
    async created() {
      const token = localStorage.getItem("token");
      const { data } = await api.get("/responses", { headers: { Authorization: `Bearer ${token}` } });
      this.answers = data.answers || [];
    },
    methods: {
      async updateResponses() {
        const token = localStorage.getItem("token");
        await api.put("/responses", { answers: this.answers }, { headers: { Authorization: `Bearer ${token}` } });
        alert("Responses updated!");
      },
    },
  };
  </script> -->
  